import script from "./UpdateTimerIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateTimerIcon.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateTimerIcon.vue?vue&type=style&index=0&id=27415311&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27415311"]])

export default __exports__